import { BaseEdge, getStraightPath, useInternalNode, EdgeToolbar, getEdgeCenter, EdgeText } from '@xyflow/react';

import { getEdgeParams } from './utils.js';
import { useEffect, useState } from 'react';
import { ContextMenu } from '../contextMenu/contextMenu.js';

function FloatingEdge({ id, source, target, markerEnd, style, label, data }) {
  const sourceNode = useInternalNode(source);
  const targetNode = useInternalNode(target);
  const [showMenu, setShowMenu] = useState(false);
  const [showLabel, setShowLabel] = useState(false)


  const { sx, sy, tx, ty } = getEdgeParams(sourceNode, targetNode);


  const [path] = getStraightPath({
    sourceX: sx,
    sourceY: sy,
    targetX: tx,
    targetY: ty,
  });

  const [centerX, centerY] = getEdgeCenter({
    sourceX: sx,
    sourceY: sy,
    targetX: tx,
    targetY: ty,
    });

  const handleContextMenu = (e) => {
    e.preventDefault()
    setShowMenu(true);
  }

  useEffect(() => {
              document.addEventListener("click", (e)=>{setShowMenu(false)});
              return () => {
                document.removeEventListener("click", (e)=>{setShowMenu(false)});
              };
            }, []);

  useEffect(() => {
        const edge = document.getElementById(id);
        const edgeContainer = edge.parentElement.parentElement
        edgeContainer.addEventListener("mouseenter", ()=>{setShowLabel(true)})
        edgeContainer.addEventListener("mouseleave", ()=>{setShowLabel(false)})
        edgeContainer.addEventListener("contextmenu", handleContextMenu)
        }, []);




  return (
    <>
        <BaseEdge
        id={id}
        className="react-flow__edge-path"
        path={path}
        markerEnd={markerEnd}
        style={{...style}}
        onClick={(e)=>{e.preventDefault();}}
        />
        {showMenu && <EdgeToolbar
            edgeId={id}
            x={centerX}
            y={centerY}
            isVisible
        >
            <ContextMenu menuPosition={{x: 0, y:0}} options={[
                    {
                        onClick: (e)=>{e.preventDefault();data.selectConn({target: target, source: source});setShowMenu(false)},
                        name: "info"
                    },
                    {
                        onClick: (e)=>{e.preventDefault();data.onDelete(id);setShowMenu(false)},
                        name: "delete"
                    }
                ]}/>
      </EdgeToolbar> }
      { showLabel && 
      <EdgeText 
        x={centerX}
        y={centerY}
        label={label}
        />}
    </>
  );
}

export default FloatingEdge;
